module.exports = __webpack_public_path__ + "img/RAPheader.4e1c989b.png";